import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import api from 'core/api';
import { WHATSAPP_GET_LIST } from '../contants';
import {
  getWhatsAppListSuccess,
  getWhatsAppListError,
} from './actions';

const getWhatsAppListRequest = async () => {
  try {
    const response = await api.get('/whatsapp/');
    return response.data;
  } catch (error) {
    throw error;
  }
};

function* getWhatsAppListItems() {
  try {
    const response = yield call(getWhatsAppListRequest);
    yield put(getWhatsAppListSuccess(response));
  } catch (error) {
    yield put(getWhatsAppListError(error.message || 'Failed to fetch WhatsApp sessions'));
  }
}

export function* watchGetWhatsAppList() {
  yield takeEvery(WHATSAPP_GET_LIST, getWhatsAppListItems);
}

export default function* rootSaga() {
  yield all([fork(watchGetWhatsAppList)]);
}
